import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { CoordinatesType } from '../../types/dataTypes';
import JSONBig from 'json-bigint';

const useBestIndex = (homeType: string, coordinates: CoordinatesType) => {
  return useQuery({
    queryKey: ['indexBest', homeType, coordinates],
    queryFn: async (): Promise<{ indexId: string | null }> => {
      const { lat, lng } = coordinates;
      if (lat === null || lng === null) return { indexId: null };

      const parameters = new URLSearchParams({
        home_type: `${[homeType]}`,
        wgs84lat: lat.toString(),
        wgs84lon: lng.toString(),
      }).toString();

      const URL = `${import.meta.env.VITE_API_INDEX_BEST_URL}?${parameters}`;

      const { data } = await axiosClient.get<{ index_id: string }>(URL, {
        transformResponse: [(raw) => {
          const parsed = JSONBig({ storeAsString: true }).parse(raw);
          return {
            index_id: parsed.index_id,
          };
        }],
      });

      return { indexId: data.index_id };
    },
  });
};

export default useBestIndex;
